import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { CreateWorkInviteParams } from '@/features/work/api/create-work-invite/request';
import { createWorkInvite } from '@/features/work/api/create-work-invite/request';

export const useCreateWorkInviteMutation = (
  settings?: MutationSettings<CreateWorkInviteParams, typeof createWorkInvite>
) =>
  useMutation({
    mutationKey: ['CreateWorkInvite'],
    mutationFn: ({ params, config }) =>
      createWorkInvite({
        params,
        config
      }),
    ...settings?.options
  });
